import rootKy, { HTTPError, KyResponse } from "ky";

import {
  requestToSnakeCase,
  responseToCamelCase,
} from "../../util/case-converter";
import { pruneRequestPayload } from "../../util/prune-api-request";
import { logError } from "./utils";

export const bad_request_status = 400;
export type apiParams = typeof ky;

export type ApiResponse<T> = Omit<KyResponse, "json"> & {
  json: () => Promise<T>;
};
export type ApiError<T> = Omit<HTTPError, "response"> & {
  response: ApiResponse<T>;
};

export type requestHeaders = HeadersInit;
const ky = rootKy.create({
  prefixUrl: "/api",
  timeout: false,
  retry: 1,
  hooks: {
    beforeRequest: [pruneRequestPayload],
    beforeError: [logError],
  },
});

// For usage in hitting external APIs
export const unprefixedKy = rootKy.create({});

export const kyWithSerializer = rootKy.create({
  prefixUrl: "/api",
  timeout: false,
  retry: 1,

  hooks: {
    beforeRequest: [requestToSnakeCase],
    afterResponse: [responseToCamelCase],
    beforeError: [logError],
  },
});

export { ky as api, HTTPError };
